module.exports = "<button mat-raised-button color=\"primary\" (click)=\"sharedService.login()\">Login</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.html
// module id = ./src/app/components/login/login.component.html
// module chunks = main